import moment from "moment";

const dangerStatuses = [
  "REFUSED",
  "REJECTED",
  "ERROR",
  "FAILED",
  "CANCELLED",
  "CANCELED",
  "INVALID",
];

const warningStatuses = [
  "PENDING",
  "WAITING",
  "DRAFT",
  "PARTIALLY_PAID",
  "NOT_APPROVED",
  "IN_PROGRESS",
];

const successStatuses = [
  "APPROVED",
  "SUCCESS",
  "ACCEPTED",
  "PAID",
  "DELIVERED",
  "COMPLETED",
  "FISCALIZED",
];

const infoStatuses = ["NEW", "SENT", "PROCESSING", "CREATED"];

export const normalizeStatus = (status) =>
  String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_?\(\d+\)$/, "");

export const getStatusTone = (status) => {
  const normalized = normalizeStatus(status);

  if (dangerStatuses.includes(normalized)) return "danger";
  if (warningStatuses.includes(normalized)) return "warning";
  if (successStatuses.includes(normalized)) return "success";
  if (infoStatuses.includes(normalized)) return "info";
  return "neutral";
};

export const formatStatusLabel = (status) =>
  String(status ?? "-").trim().replace(/_/g, " ");

const isoDateTimePattern =
  /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?(?:Z|[+-]\d{2}:\d{2})\b/g;

export const formatChatDateTimes = (text) =>
  String(text ?? "").replace(isoDateTimePattern, (value) => {
    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate.format("DD/MM/YYYY HH:mm") : value;
  });

const canonicalNumberPattern = /^-?\d+(?:\.\d+)?$/;

export const formatMoney = (value, formatter) => {
  if (value === null || value === undefined || value === "") return "-";

  if (typeof value === "number" && Number.isFinite(value)) {
    return formatter(value);
  }

  const normalized = String(value).trim();
  if (canonicalNumberPattern.test(normalized)) {
    return formatter(Number(normalized));
  }

  // Values already formatted by the API must not be parsed as decimal numbers again.
  return normalized;
};

export const getRowCurrency = (row) =>
  row?.currency || row?.ublCurrency || row?.currencyCode || "";

export const isStatusField = (key = "") =>
  String(key).toLowerCase().includes("status");

export const isCurrencyField = (key = "") => {
  const normalized = String(key).toLowerCase();
  return normalized === "currency" || normalized === "ublcurrency" || normalized === "currencycode";
};

export const isIdentifierField = (key = "") =>
  /^(eic|iic|fic|nivf|nslf|uuid)$/i.test(String(key));

export const statusValuePattern =
  /(PARTIALLY[_ ]PAID|NOT[_ ]APPROVED|IN[_ ]PROGRESS|SUCCESS(?:\s*\(\d+\))?|APPROVED|ACCEPTED|DELIVERED|COMPLETED|FISCALIZED|REFUSED|REJECTED|ERROR|FAILED|CANCELLED|CANCELED|INVALID|PENDING|WAITING|DRAFT|PROCESSING|CREATED|SENT|PAID|NEW)/gi;
